export const measurementConstants = {
  MEASUREMENT_LIST_REQUEST: "MEASUREMENT_LIST_REQUEST",
  MEASUREMENT_LIST_SUCCESS: "MEASUREMENT_LIST_SUCCESS",
  MEASUREMENT_LIST_FAILURE: "MEASUREMENT_LIST_FAILURE",

  MEASUREMENT_DETAIL_REQUEST: "MEASUREMENT_DETAIL_REQUEST",
  MEASUREMENT_DETAIL_SUCCESS: "MEASUREMENT_DETAIL_SUCCESS",
  LMEASUREMENT_DETAIL_FAILURE: "LMEASUREMENT_DETAIL_FAILURE",
};

export const routes = {
  MEASUREMENT_DETAIL: "/measurements/detail/",
  MEASUREMENTS: "/measurements",
};

export const MEASURMENT_FILTERS = {
  VIEW_ALL: {
    option: "View All",
    value:
      "C70027PL-BC55-11E2-9678-15B654818C3B,C70027DE-BC55-11E2-9678-15B654818C3B,C70027CA-BC55-11E2-9678-15B654818C3B,C70027E8-BC55-11E2-9678-15B654818C3B,C70027PQ-BC55-11E2-9678-15B654818C3B,C70027SM-BC55-11E2-9678-15B654818C3B,C7001B22-BC55-11E2-9678-15B654818C3B,69aa188b-9764-4618-9c4c-369eec9078ea,",
    checked: true,
    measurementsOnly: true,
  },
  MEASUREMENTS: {
    option: "Measurements",
    value: "",
    checked: false,
    measurementsOnly: true,
  },
  THERMAL_IMAGES: {
    option: "Thermal Images",
    value: "C70027DE-BC55-11E2-9678-15B654818C3B,",
    checked: false,
    measurementsOnly: false,
  },
  POWER_ENERGY: {
    option: "Power/Energy",
    value:
      "C70027PL-BC55-11E2-9678-15B654818C3B,C70027PQ-BC55-11E2-9678-15B654818C3B,",
    checked: false,
    measurementsOnly: false,
  },
  SCOPEMETER: {
    option: "ScopeMeter",
    value: "C70027SM-BC55-11E2-9678-15B654818C3B,",
    checked: false,
    measurementsOnly: false,
  },
  UNASSIGNED: {
    option: "Unassigned",
    value: "Unassigned",
    checked: false,
    measurementsOnly: false,
  },
};

export const MEASURMENT_SORT = {
  ALL: "Display All",
  CUSTOM_DATE: "Custom Date",
  TODAY: "Today",
  YESTERDAY: "Yesterday",
  LAST_SEVEN_DAYS: "Last 7 Days",
  LAST_THIRTY_DAYS: "Last 30 Days",
  LAST_SIX_MONTHS: "Last 6 Months",
  LAST_ONE_YEAR: "Last 1 Year",
};

export const MEASUREMENT_DATE_SORT = {
  RECENT_FIRST: {
    value: "Date (most recent first)",
    checked: true,
  },
  OLDEST_FIRST: {
    value: "Date (oldest first)",
    checked: false,
  },
};

export const MEASURMENT_TYPE_ID = {
  ALL:
    "C70027PL-BC55-11E2-9678-15B654818C3B,C70027DE-BC55-11E2-9678-15B654818C3B,C70027CA-BC55-11E2-9678-15B654818C3B,C70027E8-BC55-11E2-9678-15B654818C3B,C70027PQ-BC55-11E2-9678-15B654818C3B,C70027SM-BC55-11E2-9678-15B654818C3B,C7001B22-BC55-11E2-9678-15B654818C3B",
  MEASUREMENTS: "Measurements",
  THERMAL_IMAGES: "C70027DE-BC55-11E2-9678-15B654818C3B",
  POWER_ENERGY:
    "C70027PL-BC55-11E2-9678-15B654818C3B,C70027PQ-BC55-11E2-9678-15B654818C3B",
  UNASSIGNED: "Unassigned",
  POWER_LOGGER: "C70027PL-BC55-11E2-9678-15B654818C3B",
};

export const FILE_MEASUREMENT_TYPE_IDS = {
  THERMAL_IMAGES: "C70027DE-BC55-11E2-9678-15B654818C3B",
  CAMERA_IMAGE: "C70027CA-BC55-11E2-9678-15B654818C3B",
  CAMERA_MOVIE: "C70027E8-BC55-11E2-9678-15B654818C3B",
  POWER_QUALITY_ANALYZER: "C70027PQ-BC55-11E2-9678-15B654818C3B",
  SCOPEMETER: "C70027SM-BC55-11E2-9678-15B654818C3B",
};

export const MEASUREMENT_TYPE_INSULATION_IDS = {
  RESISTANCE: "C7001B22-BC55-11E2-9678-15B654818C3B",
  KILO_RESISTANCE: "C7001AFA-BC55-11E2-9678-15B654818C3B",
  MEGA_RESISTANCE: "C7001AF0-BC55-11E2-9678-15B654818C3B",
  TERA_RESISTANCE: "F6CAD4FA-18F9-46B6-A044-A2B8399D0FA9",
  GIGA_RESISTANCE: "6C8B3049-1C4E-4247-ACC3-5112CCBE3F98",
};

export const MEASUREMENT_DEVICE_TYPE = {
  POWER_LOGGER_IMAGE_MODE: "PowerLoggerImageMode",
  CAMERA: "Camera",
};

export const CONFIGURATION = {
  LINE_NEUTRAL: "L-N",
  NEUTRAL_POTENTIAL_EARTH: "N-PE",
  LINE_POTENTIAL_EARTH: "L-PE",
};

export const HUDSON_TEST = {
  CONTINUITY_TEST: "Continuity Test",
  INSULATION_TEST: "Insulation Test",
  VOLTAGE_TEST: "Voltage",
  PHASE_SEQUENCE_TEST: "Phase Sequence Test",
  EARTH_GROUND_TEST: "Earth Ground Test",
  NO_TRIP_LOOP_TEST: "No Trip Loop Test",
  RCD_TRIPPING_TIME_TEST: "RCD Tripping Time Test",
  RCD_TRIPPING_TIME_TEST_AUTO: "RCD Tripping Time Test (Auto)",
  RCD_TRIPPING_CURRENT_TEST: "RCD Tripping Current Test",
  HIGH_CURRENT_LOOP_TEST: "High-Current Loop Test",
  AUTO_TEST: "Auto Test",
};

export const READINGSTATES = {
  NORMAL: 0,
  BLANK: 1,
  INACTIVE: 2,
  INVALID: 3,
  OL_RANGE: 4,
  OL_A2D: 5,
  OPEN_TC: 6,
  DISCHARGE: 7,
  LEADS: 8,
  GREATER_THAN: 9,
  MISSING_PHASE: 10,
  ERROR: 11,
  LESS_THAN: 12,
  UNSPECIFIED: 13,
  LESS_THAN_VAL: 16,
};

export const DISPLAYSTATES = {
  0: "",
  1: "----",
  2: "OL",
  3: "Open",
  4: "Leads",
};

export const DISPLAYSTATES_LABELS = {
  BLANK: "",
  INVALID: "----",
  OL: "OL",
  OPEN: "Open",
  LEADS: "Leads",
};

export const SIGN = {
  PLUS: "+",
  MINUS: "-",
  PLUS_OR_MINUS: "±",
};

export const VOLTAGES = {
  FIFTY: "50 V",
  HUNDRED: "100 V",
  TWO_HUNDRED_FIFTY: "250 V",
  FIVE_HUNDRED: "500 V",
  THOUSAND: "1000 V",
};

export const PHASE_ROTATION = {
  ZERO: "0°",
  ONE_HUNDRED_EIGHTY: "180°",
  AUTO: "Auto",
};

export const ZMAX = {
  ON: "Zmax ON",
  OFF: "Zmax OFF",
};

export const PRETEST = {
  ON: "Pretest on",
  OFF: "Pretest off",
};
export const MILLI_AMPHERES = {
  TEN: "10 mA",
  THIRTY: "30 mA",
  HUNDRED: "100 mA",
  TWO_HUNDRED_FIFTY: "250 mA",
  THREE_HUNDRED: "300 mA",
  FIVE_HUNDRED: "500 mA",
  THOUSAND: "1000 mA",
  VARIABLE: " mA",
};

export const MULTIPLIER = {
  HALF: "1/2x",
  ONE: "1x",
  FIVE: "5x",
  AUTO: "Auto",
};

export const CONFIGURATION_VOLTAGE = {
  TWENTY_FIVE: " =25 V",
  FIFTY: " =50 V",
};

export const UNITS = {
  HERTZ: "Hz",
  VOLTAGE: "V",
  AMPHERE: "A",
  MILLI_AMPHERES: "mA",
  VOLTAGE_AC: "V AC",
  VOLTAGE_DC: "V DC",
  AMPHERE_AC: "A AC",
  AMPHERE_DC: "A DC",
  SECONDS: "sec",
  MILLI_SECONDS: "msec",
  OHM: "Ω",
  MB: "MB",
  KILO_VOLTS: "kV",
  KILO_WATTS: "kW",
};

export const HUDSON_MEASUREMENT = {
  SYMBOL_R: "R",
  SYMBOL_LO: "LO",
  SYMBOL_ISO: "ISO",
  SYMBOL_U: "U",
  SYMBOL_N: "N",
  SYMBOL_Z: "Z",
  SYMBOL_E: "E",
  SYMBOL_K: "K",
  SYMBOL_L: "L",
  SYMBOL_F: "F",
  SYMBOL_i: "i",
  SYMBOL_PSC_I: "PSC I",
  SYMBOL_PEFC_I: "PEFC I",
  SYMBOL_DEL_T: "ΔT",
  SYMBOL_I_DEL: "IΔ",
  SYMBOL_L_MAX: "L max",
  SYMBOL_i_MAX: "i max",
};

export const TEST_MODE = {
  VOLTAGE_TEST: 2,
  CONTINUITY_TEST: 39,
  INSULATION_TEST: 55,
  HIGH_CURRENT_LOOP_TEST: 59,
  NO_TRIP_LOOP_TEST: 60,
  RCD_TRIPPING_TIME_TEST: 65,
  RCD_TRIPPING_TIME_TEST_AUTO: 66,
  RCD_TRIPPING_CURRENT_TEST: 67,
  PHASE_SEQUENCE_TEST: 68,
  EARTH_GROUND_TEST: 69,
  AUTO_TEST: 72,
};

export const HUDSON_GROUP_VALUES = {
  VAL_0: 0,
  VAL_1: 1,
  VAL_2: 2,
  VAL_16: 16,
  VAL_32: 32,
  VAL_48: 48,
  VAL_64: 64,
  VAL_128: 128,
  VAL_256: 256,
  VAL_512: 512,
  VAL_768: 768,
  VAL_1024: 1024,
  VAL_1280: 1280,
  VAL_4096: 4096,
  VAL_8192: 8192,
  VAL_12288: 12288,
  VAL_16384: 16384,
  VAL_20480: 20480,
  VAL_24576: 24576,
};

export const MEASURMENT_MAGNITUDE_ID = {
  NONE: "70b7de18-2ca7-11e3-a0fd-2c9c88d79c89",
};

export const EEVEE_THRESHOLD = {
  NORMAL: 10000,
};

export const VOLTAGE_CURRENT_UNITS = {
  VAC: "VAC",
  VDC: "VDC",
  AAC: "AAC",
  ADC: "ADC",
};

export const INSULATION_TEST_FUNCTION = {
  0: "",
  1: "PI",
  2: "DAR",
};

export const INSULATION_TEST_FUNCTION_VALUE = {
  NONE: 0,
  PI: 1,
  DAR: 2,
};

export const TEMPERATURE_UNIT = {
  F: "F",
  C: "C",
};

export const TEMPERATURE_META_DATA_VALUE = {
  FAHRENHEIT: "8",
  CELCIUS: "7",
};

export const TEMPERATURE_OBJECT = {
  PREFERENCE_VALUE: "C7001ABE-BC55-11E2-9678-15B654818C3B",
};

export const MEAS_TYPE_ID = {
  DEGREE_F: "C7001AE6-BC55-11E2-9678-15B654818C3B",
  DEGREE_C: "C7001ABE-BC55-11E2-9678-15B654818C3B",
  VIBRATION_IN_G: "4c2f2813-02e7-4a19-a483-0ad08c7d5b22",
  VIBRATION_IN_IPS: "e90987f0-6090-4918-9ee2-ec8cff0bad5d",
  VIBRATION_IN_MPS2: "75f5afa2-9c36-403f-be29-18f12653cd17",
  VIBRATION_IN_RMS: "C70027SM-BC55-11E2-9678-15B654818C3B",
  VIBRATION_IN_MMPS: "c50a543c-e0a4-42d4-8b45-839aa3e185c4",
  VIBRATION_IN_MILS: "bd59141a-3805-44da-9571-a42b59aa0050",
  VIBRATION_IN_MICRON: "ba43323b-385b-43ad-b693-9337ab422654",
  VAC: "C7001B2D-BC55-11E2-9678-15B654818C3B",
  VDC: "C7001B37-BC55-11E2-9678-15B654818C3B",
  AAC: "C7001B41-BC55-11E2-9678-15B654818C3B",
  ADC: "C7001BA4-BC55-11E2-9678-15B654818C3B",
  HZ: "C70025EB-BC55-11E2-9678-15B654818C3B",
};

export const MEASUREMENT_READING_UNIT_ID = {
  READING_UNIT_NONE: 0,
  READING_UNIT_VAC: 1,
  READING_UNIT_VDC: 2,
  READING_UNIT_AAC: 3,
  READING_UNIT_ADC: 4,
  READING_UNIT_HZ: 5,
  READING_UNIT_RH_PCT: 6,
  READING_UNIT_DEGC: 7,
  READING_UNIT_DEGF: 8,
  READING_UNIT_DEG_RANKINE: 9,
  READING_UNIT_KELVIN: 10,
  READING_UNIT_OHMS: 11,
  READING_UNIT_SIEMENS: 12,
  READING_UNIT_DUTY_PCT: 13,
  READING_UNIT_SECONDS: 14,
  READING_UNIT_FARADS: 15,
  READING_UNIT_DB: 16,
  READING_UNIT_DBM: 17,
  READING_UNIT_WATTS: 18,
  READING_UNIT_JOULE: 19,
  READING_UNIT_HENRY: 20,
  READING_UNIT_PSI: 21,
  READING_UNIT_HG_METERS: 22,
  READING_UNIT_G_PER_CM_SQUARED: 30,
  READING_UNIT_VAC_PLUS_DC: 33,
  READING_UNIT_AAC_PLUS_DC: 34,
  READING_UNIT_PERCENT: 35,
  READING_UNIT_VAC_OVER_HZ: 36,
  READING_UNIT_ACCELERATION_G: 37,
  READING_UNIT_VELOCITY_IPS: 39,
  READING_UNIT_VELOCITY_MMPS: 40,
  READING_UNIT_UNKNOWN: 43,
  READING_UNIT_TERA_OHMS: 44,
  READING_UNIT_VADC: 45,
  READING_UNIT_VAAC: 47,
};

export const MEASUREMENT_READING_UNIT_LABEL = {
  READING_UNIT_NONE: "",
  READING_UNIT_VAC: "V AC",
  READING_UNIT_NEW_LABEL_VAC: "Vac",
  READING_UNIT_VDC: "V DC",
  READING_UNIT_VDC_NEW_LABEL: "Vdc",
  READING_UNIT_AAC: "A AC",
  READING_UNIT_AAC_NEW_LABEL: "Aac",
  READING_UNIT_ADC: "A DC",
  READING_UNIT_ADC_NEW_LABEL: "Adc",
  READING_UNIT_HZ: "Hz",
  READING_UNIT_RH_PCT: "rH pct",
  READING_UNIT_DEGC: "°C",
  READING_UNIT_DEGF: "°F",
  READING_UNIT_DEG_RANKINE: "ranK",
  READING_UNIT_KELVIN: "K",
  READING_UNIT_OHMS: "Ω",
  READING_UNIT_SIEMENS: "S",
  READING_UNIT_DUTY_PCT: "duty %",
  READING_UNIT_SECONDS: "sec",
  READING_UNIT_FARADS: "F",
  READING_UNIT_DB: "dB",
  READING_UNIT_DBM: "dBM",
  READING_UNIT_WATTS: "W",
  READING_UNIT_JOULE: "J",
  READING_UNIT_HENRY: "H",
  READING_UNIT_PSI: "PSI",
  READING_UNIT_HG_METERS: "m",
  READING_UNIT_G_PER_CM_SQUARED: "g/cm2",
  READING_UNIT_VAC_PLUS_DC: "V AC+DC",
  READING_UNIT_AAC_PLUS_DC: "A AC+DC",
  READING_UNIT_PERCENT: "%",
  READING_UNIT_VAC_OVER_HZ: "VAC/Hz",
  READING_UNIT_ACCELERATION_G: "g",
  READING_UNIT_VELOCITY_IPS: "m/s^2",
  READING_UNIT_VELOCITY_MMPS: "mm/s",
  READING_UNIT_UNKNOWN: "Unknown",
  READING_UNIT_TERA_OHMS: "TΩ",
  READING_UNIT_VADC: "VAdc",
  READING_UNIT_VAAC: "VAac",
};

export const MEASUREMENT_READING_MAGNITUDE_ID = {
  READING_MAGNITUDE_NONE: 0,
  READING_MAGNITUDE_GIGA: 1,
  READING_MAGNITUDE_MEGA: 2,
  READING_MAGNITUDE_KILO: 3,
  READING_MAGNITUDE_MILLI: 4,
  READING_MAGNITUDE_MICRO: 5,
  READING_MAGNITUDE_NANO: 6,
  READING_MAGNITUDE_PICO: 7,
  READING_MAGNITUDE_TERA: 10,
  READING_MAGNITUDE_PETA: 9,
  READING_MAGNITUDE_EXA: 9,
  READING_MAGNITUDE_ATTO: 9,
  READING_MAGNITUDE_FEMTO: 9,
};

export const MEASUREMENT_READING_MAGNITUDE_LABEL = {
  READING_MAGNITUDE_NONE: "",
  READING_MAGNITUDE_GIGA: "G",
  READING_MAGNITUDE_MEGA: "M",
  READING_MAGNITUDE_KILO: "k",
  READING_MAGNITUDE_MILLI: "m",
  READING_MAGNITUDE_MICRO: "µ",
  READING_MAGNITUDE_NANO: "n",
  READING_MAGNITUDE_PICO: "p",
  READING_MAGNITUDE_TERA: "T",
  READING_MAGNITUDE_PETA: "P",
  READING_MAGNITUDE_EXA: "E",
  READING_MAGNITUDE_ATTO: "a",
  READING_MAGNITUDE_FEMTO: "f",
};

export const MEASUREMENT_READING_MAGNITUDE_VALUE = {
  READING_MAGNITUDE_NONE: { value: 0, label: "" },
  READING_MAGNITUDE_GIGA: { value: 9, label: "G" },
  READING_MAGNITUDE_MEGA: { value: 6, label: "M" },
  READING_MAGNITUDE_KILO: { value: 3, label: "k" },
  READING_MAGNITUDE_MILLI: { value: -3, label: "m" },
  READING_MAGNITUDE_MICRO: { value: -6, label: "µ" },
  READING_MAGNITUDE_NANO: { value: -9, label: "n" },
  READING_MAGNITUDE_PICO: { value: -12, label: "p" },
  READING_MAGNITUDE_TERA: { value: 12, label: "T" },
  READING_MAGNITUDE_PETA: { value: 15, label: "P" },
  READING_MAGNITUDE_EXA: { value: 18, label: "E" },
  READING_MAGNITUDE_ATTO: { value: -18, label: "a" },
  READING_MAGNITUDE_FEMTO: { value: -15, label: "f" },
};

export const MEASUREMENT_READING_FUNCTION_ID = {
  READING_FUNCTION_NONE: 0,
  READING_FUNCTION_MVAC: 1,
  READING_FUNCTION_VAC: 2,
  READING_FUNCTION_VAC_PLUS_DC: 3,
  READING_FUNCTION_MVAC_AVG: 4,
  READING_FUNCTION_VAC_AVG: 5,
  READING_FUNCTION_VAC_AVG_PLUS_DC: 6,
  READING_FUNCTION_VAC_LOZ: 7,
  READING_FUNCTION_MVAC_LOPASS: 8,
  READING_FUNCTION_VAC_LOPASS: 9,
  READING_FUNCTION_UVDC: 10,
  READING_FUNCTION_MVDC: 11,
  READING_FUNCTION_VDC: 12,
  READING_FUNCTION_MAAC: 13,
  READING_FUNCTION_AAC: 14,
  READING_FUNCTION_AAC_PLUS_DC: 15,
  READING_FUNCTION_MAAC_AVG: 16,
  READING_FUNCTION_AAC_AVG: 17,
  READING_FUNCTION_AAC_AVG_PLUS_DC: 18,
  READING_FUNCTION_UADC: 19,
  READING_FUNCTION_MADC: 20,
  READING_FUNCTION_ADC: 21,
  READING_FUNCTION_HZ_MVAC: 22,
  READING_FUNCTION_HZ_VAC: 23,
  READING_FUNCTION_HZ_MVAC_LOPASS: 24,
  READING_FUNCTION_HZ_VAC_LOPASS: 25,
  READING_FUNCTION_HZ_MVDC: 26,
  READING_FUNCTION_HZ_VDC: 27,
  READING_FUNCTION_HZ_UAAC: 28,
  READING_FUNCTION_HZ_MAAC: 29,
  READING_FUNCTION_HZ_AAC: 30,
  READING_FUNCTION_HZ_UADC: 31,
  READING_FUNCTION_HZ_MADC: 32,
  READING_FUNCTION_HZ_ADC: 33,
  READING_FUNCTION_TEMP: 34,
  READING_FUNCTION_DEGF: 35,
  READING_FUNCTION_DEGC: 36,
  READING_FUNCTION_DEG_RANKINE: 37,
  READING_FUNCTION_KELVIN: 38,
  READING_FUNCTION_CONTINUITY: 39,
  READING_FUNCTION_RESISTANCE: 40,
  READING_FUNCTION_CONDUCTANCE: 41,
  READING_FUNCTION_LOW_OHMS: 42,
  READING_FUNCTION_DEGREES_PHASE: 43,
  READING_FUNCTION_AAC_INRUSH: 44,
  READING_FUNCTION_CAPS: 45,
  READING_FUNCTION_DIODE: 46,
  READING_FUNCTION_VAC_OVER_HZ: 47,
  READING_FUNCTION_MVAC_DC: 48,
  READING_FUNCTION_MAAC_DC: 49,
  READING_FUNCTION_UAAC: 50,
  READING_FUNCTION_UAAC_DC: 51,
  READING_FUNCTION_TEST_VDC: 52,
  READING_FUNCTION_FAULT_VAC: 53,
  READING_FUNCTION_TOUCH_VAC_LIMIT: 54,
  READING_FUNCTION_INSULATION: 55,
  READING_FUNCTION_CONTINUITY_POSITIVE: 56,
  READING_FUNCTION_CONTINUITY_NEGATIVE: 57,
  READING_FUNCTION_CONTINUITY_AVERAGE: 58,
  READING_FUNCTION_LOOP_TRIP: 59,
  READING_FUNCTION_LOOP_NO_TRIP: 60,
  READING_FUNCTION_LOOP_IMPEDANCE: 61,
  READING_FUNCTION_LOOP_IMPEDANCE_MAX: 62,
  READING_FUNCTION_LINE_IMPEDANCE: 63,
  READING_FUNCTION_LINE_IMPEDANCE_MAX: 64,
  READING_FUNCTION_RCD_TIME: 65,
  READING_FUNCTION_RCD_TIME_AUTO: 66,
  READING_FUNCTION_RCD_RAMP: 67,
  READING_FUNCTION_PHASE_ROTATION: 68,
  READING_FUNCTION_EARTH_RESISTANCE: 69,
  READING_FUNCTION_EARTH_FAULT_CURRENT: 70,
  READING_FUNCTION_SHORT_CIRCUIT_CURRENT: 71,
  READING_FUNCTION_MFT_AUTO_TEST: 72,
  READING_FUNCTION_INSULATION_SPOT_VOLTS_DETECT: 73,
  READING_FUNCTION_INSULATION_SPOT_TEST: 74,
  READING_FUNCTION_INSULATION_PI_VOLTS_DETECT: 75,
  READING_FUNCTION_INSULATION_PI_TEST: 76,
  READING_FUNCTION_INSULATION_PI_RESULT: 77,
  READING_FUNCTION_INSULATION_DAR_VOLTS_DETECT: 78,
  READING_FUNCTION_INSULATION_DAR_TEST: 79,
  READING_FUNCTION_INSULATION_DAR_RESULT: 80,
  READING_FUNCTION_1555_RAMP_VOLTS_DETECT: 81,
  READING_FUNCTION_1555_RAMP_VOLTS_TEST: 82,
  READING_FUNCTION_1555_DAR_CHINA_VOLTS_DETECT: 83,
  READING_FUNCTION_1555_DAR_CHINA_VOLTS_TEST: 84,
  READING_FUNCTION_1555_DAR_CHINA_RESULT: 85,
  READING_FUNCTION_PRESSURE: 86,
  READING_FUNCTION_37X_FIELD_SENSE: 87,
};
export const KEY_EVENTS = {
  KEY_8: 8,
  KEY_37: 37,
  KEY_39: 39,
  KEY_48: 48,
  KEY_58: 58,
  KEY_190: 190,
};

export const TEMP_VALUES = {
  TEMP_200: "200.00",
  TEMP_392: "392.00",
};

export const MEASUREMENT_READING_FUNCTION_LABEL = {
  READING_FUNCTION_NONE: "",
  READING_FUNCTION_MVAC: "mVAC",
  READING_FUNCTION_VAC: "VAC",
  READING_FUNCTION_VAC_PLUS_DC: "VAC+DC",
  READING_FUNCTION_MVAC_AVG: "mVAC avg",
  READING_FUNCTION_VAC_AVG: "VAC avg",
  READING_FUNCTION_VAC_AVG_PLUS_DC: "VAC avg + DC",
  READING_FUNCTION_VAC_LOZ: "LOZ",
  READING_FUNCTION_MVAC_LOPASS: "Lopass",
  READING_FUNCTION_VAC_LOPASS: "VAC lopass",
  READING_FUNCTION_UVDC: "uVDC",
  READING_FUNCTION_MVDC: "mVDC",
  READING_FUNCTION_VDC: "VDC",
  READING_FUNCTION_MAAC: "mAAC",
  READING_FUNCTION_AAC: "AAC",
  READING_FUNCTION_AAC_PLUS_DC: "AAC+DC",
  READING_FUNCTION_MAAC_AVG: "mAAC avg",
  READING_FUNCTION_AAC_AVG: "AAC avg",
  READING_FUNCTION_AAC_AVG_PLUS_DC: "AAC avg + DC",
  READING_FUNCTION_UADC: "uADC",
  READING_FUNCTION_MADC: "mADC",
  READING_FUNCTION_ADC: "ADC",
  READING_FUNCTION_HZ_MVAC: "Hz mVAC",
  READING_FUNCTION_HZ_MVAC_NEW_LABEL: "Hz mVac",
  READING_FUNCTION_HZ_VAC: "Hz VAC",
  READING_FUNCTION_HZ_VAC_NEW_LABEL: "Hz Vac",
  READING_FUNCTION_HZ_MVAC_LOPASS: "Hz mVAC lopass",
  READING_FUNCTION_HZ_VAC_LOPASS: "Hz VAC lopass",
  READING_FUNCTION_HZ_MVDC: "Hz mVDC",
  READING_FUNCTION_HZ_MVDC_NEW_LABEL: "Hz mVdc",
  READING_FUNCTION_HZ_VDC: "Hz VDC",
  READING_FUNCTION_HZ_VDC_NEW_LABEL: "Hz Vdc",
  READING_FUNCTION_HZ_UAAC: "Hz uAAC",
  READING_FUNCTION_HZ_MAAC: "Hz mAAC",
  READING_FUNCTION_HZ_MAAC_NEW_LABEL: "Hz mAac",
  READING_FUNCTION_HZ_AAC: "Hz AAC",
  READING_FUNCTION_HZ_AAC_NEW_LABEL: "Hz Aac",
  READING_FUNCTION_HZ_UADC: "uADC",
  READING_FUNCTION_HZ_MADC: "mADC",
  READING_FUNCTION_HZ_MADC_NEW_LABEL: "mAdc",
  READING_FUNCTION_HZ_ADC: "Hz ADC",
  READING_FUNCTION_HZ_ADC_NEW_LABEL: "Hz Adc",
  READING_FUNCTION_TEMP: "Temp",
  READING_FUNCTION_DEGF: "°F",
  READING_FUNCTION_DEGC: "°C",
  READING_FUNCTION_DEG_RANKINE: "°R",
  READING_FUNCTION_KELVIN: "°K",
  READING_FUNCTION_CONTINUITY: "cont",
  READING_FUNCTION_RESISTANCE: "Ω",
  READING_FUNCTION_CONDUCTANCE: "conduct",
  READING_FUNCTION_LOW_OHMS: "Ω",
  READING_FUNCTION_DEGREES_PHASE: "deg phase",
  READING_FUNCTION_AAC_INRUSH: "AAC inrush",
  READING_FUNCTION_CAPS: "caps",
  READING_FUNCTION_DIODE: "diode",
  READING_FUNCTION_VAC_OVER_HZ: "VAC/Hz",
  READING_FUNCTION_MVAC_DC: "mVAC+DC",
  READING_FUNCTION_MAAC_DC: "mAAC+DC",
  READING_FUNCTION_UAAC: "uAAC",
  READING_FUNCTION_UAAC_DC: "uAAC+DC",
  READING_FUNCTION_TEST_VDC: "Test DC Voltage (Insulation)",
  READING_FUNCTION_FAULT_VAC: "Fault AC Voltage",
  READING_FUNCTION_TOUCH_VAC_LIMIT: "Touch AC Voltage Limit",
  READING_FUNCTION_INSULATION: "Insulation (Insulation Resistance)",
  READING_FUNCTION_CONTINUITY_POSITIVE:
    "Continuity With Positive Test Current Polarity",
  READING_FUNCTION_CONTINUITY_NEGATIVE:
    "Continuity With Positive Test Current Polarity",
  READING_FUNCTION_CONTINUITY_AVERAGE:
    "Continuity Average across Positive and Negative Polarities",
  READING_FUNCTION_LOOP_TRIP: "Loop Trip (High Current)",
  READING_FUNCTION_LOOP_NO_TRIP: "Loop No Trip",
  READING_FUNCTION_LOOP_IMPEDANCE: "Loop Impedance",
  READING_FUNCTION_LOOP_IMPEDANCE_MAX: "Loop Impedance - Maximum",
  READING_FUNCTION_LINE_IMPEDANCE: "Line Impedance",
  READING_FUNCTION_LINE_IMPEDANCE_MAX: "Line Impedance Maximum",
  READING_FUNCTION_RCD_TIME: "RCD Time",
  READING_FUNCTION_RCD_TIME_AUTO: "RCD Time Auto",
  READING_FUNCTION_RCD_RAMP: "RCD Ramp",
  READING_FUNCTION_PHASE_ROTATION: "Phase Rotation",
  READING_FUNCTION_EARTH_RESISTANCE: "Earth Resistance",
  READING_FUNCTION_EARTH_FAULT_CURRENT: "Earth Fault Current",
  READING_FUNCTION_SHORT_CIRCUIT_CURRENT: "Short Circuit Current",
  READING_FUNCTION_MFT_AUTO_TEST: "MFT Auto Test",
  READING_FUNCTION_INSULATION_SPOT_VOLTS_DETECT: "spot volts det",
  READING_FUNCTION_INSULATION_SPOT_TEST: "spot test",
  READING_FUNCTION_INSULATION_PI_VOLTS_DETECT: "pi volts det",
  READING_FUNCTION_INSULATION_PI_TEST: "pi test",
  READING_FUNCTION_INSULATION_PI_RESULT: "pi results",
  READING_FUNCTION_INSULATION_DAR_VOLTS_DETECT: "dar volts det",
  READING_FUNCTION_INSULATION_DAR_TEST: "dar test",
  READING_FUNCTION_INSULATION_DAR_RESULT: "dar results",
  READING_FUNCTION_1555_RAMP_VOLTS_DETECT: "ramp volts det",
  READING_FUNCTION_1555_RAMP_VOLTS_TEST: "ramp volts test",
  READING_FUNCTION_1555_DAR_CHINA_VOLTS_DETECT: "dar china volts det",
  READING_FUNCTION_1555_DAR_CHINA_VOLTS_TEST: "dar china volts test",
  READING_FUNCTION_1555_DAR_CHINA_RESULT: "dar china volts result",
  READING_FUNCTION_PRESSURE: "Pressure",
  READING_FUNCTION_37X_FIELD_SENSE: "Field Sense",
};

export const RAMP_STATUS = {
  null: "Not Available",
  0: "Off",
  1: "On",
};

export const EeveeTestEndedBy = {
  null: "Not Available",
  0: "Not Available",
  1: "By User",
  2: "Breakdown",
  3: "Noise",
  4: "Time Limited",
  5: "Battery Depleted",
};

export const IMAGE_FILE_FORMATS = {
  JPG: "jpg",
  BMP: "bmp",
  JPEG: "jpeg",
  PNG: "png",
  THUMB: ".thumb",
  IS2: "is2",
};

export const FC37X_MODE_ATTRIBUTES_ROTATION = {
  NONE: 0,
  ROTATION_UNDETERMINED: 1,
  CLOCKWISE: 2,
  COUNTER_CLOCKWISE: 3,
  MIN: 4,
  MAX: 5,
  AVG: 6,
  LIVE: 7,
  AUTO_HOLD: 8,
};

export const FC37X_MODE_ATTRIBUTES_PQ = {
  NONE: 0,
  PQ_VOLTS: 1,
  PQ_AMPS: 2,
  PQ_VOLTS_PQ_AMPS: 3,
  PQ_PF: 4,
  PQ_VOLTS_PQ_PF: 5,
  PQ_AMPS_PQ_PF: 6,
  PQ_VOLTS_PQ_AMPS_PQ_PF: 7,
};

export const FC37X_MODE_ATTRIBUTES_FUNCTION = {
  NONE: 0,
  PHASE_TO_PHASE: 1,
  HOLD: 2,
  IN_RUSH: 3,
};

export const FC37X_PHASE_2_PHASE_FUNCTION = {
  L1_L2_L3: "L1-L2-L3",
  L1_N: "L1-N",
  L2_N: "L2-N",
  L3_N: "L3-N",
  L1_L2: "L1-L2:",
  L2_L3: "L2-L3:",
  L3_L1: "L3-L1:",
  AAC_CLAMP: 7,
  AAC_IFLEX: 8,
};

export const FLK173X_TOPOLOGY = {
  SINGLE_PHASE: 0,
  THREE_PHASE_WYE: 1,
  THREE_PHASE_DELTA: 2,
  SPLIT_PHASE: 3,
  SINGLE_PHASE_IT: 4,
  THREE_PHASE_WYE_IT: 5,
  THREE_PHASE_HIGH_LEG_DELTA: 6,
  THREE_PHASE_DELTA_OPEN_LEG: 7,
  THREE_PHASE_TWO_ELEMENT_DELTA: 9,
  THREE_PHASE_WYE_BALANCED: 11,
  THREE_PHASE_DELTA_BALANCED: 12,
};

export const FLK173X_TOPOLOGY_TEXT = {
  SINGLE_PHASE: "Single Phase",
  THREE_PHASE_WYE: "3-ɸ Wye",
  THREE_PHASE_DELTA: "3-ɸ Delta",
  SPLIT_PHASE: "Split Phase",
  SINGLE_PHASE_IT: "Single Phase IT",
  THREE_PHASE_WYE_IT: "3-ɸ Wye IT",
  THREE_PHASE_HIGH_LEG_DELTA: "3-ɸ High Leg Delta",
  THREE_PHASE_DELTA_OPEN_LEG: "3-ɸ Delta Open Leg",
  THREE_PHASE_TWO_ELEMENT_DELTA: "3-ɸ 2 Element Delta",
  THREE_PHASE_WYE_BALANCED: "3-ɸ Wye balanced",
  THREE_PHASE_DELTA_BALANCED: "3-ɸ Delta balanced",
};

export const FLK173X_STUDY_TYPE = {
  UNKNOWN: 0,
  ENERGY: 1,
  LOAD: 2,
};

export const FLK173X_STUDY_TYPE_TEXT = {
  UNKNOWN: "Unknown",
  ENERGY: "Energy Study",
  LOAD: "Load Study",
};

export const FLK173X_TYPES = {
  V_THD: "V - THD",
  A_THD: "A - THD",
  A_THC: "A - THC",
  DIPS: "Dips",
  SWELLS: "Swells",
  INTERRUPTIONS: "Interruptions",
  INRUSH_CURRENT: "Inrush Current",
  ACTIVE_ENGERGY: "Active Energy(RMS)",
  ENERGY_OVERVIEW: "Energy Overview",
  ELAPSED_TIME: "Elapsed Time",
  FORWARD: "Forward",
  REVERSE: "Reverse",
};

export const FLK173X_SCREENS = {
  SCREEN1: 1,
  SCREEN2: 2,
  SCREEN3: 3,
  SCREEN4: 4,
  SCREEN5: 5,
  SCREEN6: 6,
};

export const FLK173X_SESSION_STATE = {
  INACTIVE: 0,
  PENDING: 1,
  RUNNING: 2,
  FINISHED: 3,
  INITIAL: 4,
};

export const FLK173X_LOG_INDICATOR = {
  INACTIVE: "",
  PENDING: "Logging Pending",
  RUNNING: "Logging In Progress",
  FINISHED: "Logging Completed",
};

export const FLK173X_CHANNEL = {
  A: "A",
  B: "B",
  C: "C",
  N: "N",
  TOTAL: "Total",
  VOLTAGE_DIPS: "Voltage dips",
  VOLTAGE_SWELLS: "Voltage swells",
  INTERRUPTIONS: "Interruptions",
  INRUSH_CURRENT: "Inrush Current",
  VOLTAGE: "Voltage",
  CURRENT: "Current",
  FREQUENCY: "Frequency",
  ACTIVE_POWER: "Active Power",
  POWER_FACTOR: "Power Factor",
  THD_VOLTAGE: "THD Voltage",
  THD_CURRENT: "THD Current",
  HARMONIC_CONTENT_CURRENT: "Harmonic Content Current",
  ACTIVE_ENGERGY: "Active Energy",
  APPARENT_ENERGY: "Apparent Energy",
  REACTIVE_ENERGY: "Reactive Energy",
  FORWARD_ACTIVE_ENERGY: "Forward Active Energy",
  REVERSE_ACTIVE_ENERGY: "Reverse Active Energy",
};

export const VIBRATION_TOOL = {
  MACHINE_CATEGORY_1: "Axial Flow Fan",
  MACHINE_CATEGORY_2: "Belt Drive (Motor & Fan)",
  MACHINE_CATEGORY_3: "Belt-Driven Fans 600-1799 RPM",
  MACHINE_CATEGORY_4: "Belt-Driven Fans 1800-3600 RPM",
  MACHINE_CATEGORY_5: "Boiler Feed Pump",
  MACHINE_CATEGORY_6: "Centrif Air Comp-Int Gear (Axial)",
  MACHINE_CATEGORY_7: "Centrif Air Comp-Int Gear (Radial)",
  MACHINE_CATEGORY_8: "Centrif Air Compressor",
  MACHINE_CATEGORY_9: "Centrifugal Chillers",
  MACHINE_CATEGORY_10: "Direct Drive (Motor & Fan)",
  MACHINE_CATEGORY_11: "Direct Drive Fans",
  MACHINE_CATEGORY_12: "Forced Draft Fans-Fim brgs",
  MACHINE_CATEGORY_13: "Gearbox Input",
  MACHINE_CATEGORY_14: "Gearbox Output",
  MACHINE_CATEGORY_15: "Horiz Centrif Double Suction",
  MACHINE_CATEGORY_16: "Horiz Centrif Single Suction",
  MACHINE_CATEGORY_17: "Induced Draft Fans-Film brgs",
  MACHINE_CATEGORY_18: "Long, Hollow Drive Shaft (Motor)",
  MACHINE_CATEGORY_19: "Machine Tool Motor",
  MACHINE_CATEGORY_20: "Multi-Stage Centrif Blower",
  MACHINE_CATEGORY_21: "Pos Disp Gear Pump",
  MACHINE_CATEGORY_22: "Pos Disp Piston Pump",
  MACHINE_CATEGORY_23: "Recip Chillers (Hermetic Motor)",
  MACHINE_CATEGORY_24: "Recip Chillers (Open Motor)",
  MACHINE_CATEGORY_25: "Reciprocating Air Compressors",
  MACHINE_CATEGORY_26: "Rotary Lobe Blower",
  MACHINE_CATEGORY_27: "Rotary Screw Air Compressors",
  MACHINE_CATEGORY_28: "Shaft Mounted Integral Fan",
  MACHINE_CATEGORY_29: "Single Stage Gearbox",
  MACHINE_CATEGORY_30: "Spindle-Critical Finishing",
  MACHINE_CATEGORY_31: "Spindle-Machine Finishing",
  MACHINE_CATEGORY_32: "Spindle-Roughing Operation",
  MACHINE_CATEGORY_33: "Vacuum Blowers (Belt or Direct)",
  MACHINE_CATEGORY_34: "Vertical Pumps (0'-5' Height)",
  MACHINE_CATEGORY_35: "Vertical Pumps (5'-8' Height)",
  MACHINE_CATEGORY_36: "Vertical Pumps (8'-12' Height)",
  MACHINE_CATEGORY_37: "Vertical Pumps (12'-20' Height)",
  MACHINE_CATEGORY_38: "Unassigned",
  SEVERITY_TEXT_1: "slight",
  SEVERITY_TEXT_2: "moderate",
  SEVERITY_TEXT_3: "serious",
  SEVERITY_TEXT_4: "extreme",
  BEARING_SEVERITY_THRESHOLD_SLIGHT: 5.0,
  BEARING_SEVERITY_THRESHOLD_MODERATE: 10.0,
  BEARING_SEVERITY_THRESHOLD_SERIOUS: 15.0,
  SEVERITY_VALUE_1: 1,
  SEVERITY_VALUE_2: 2,
  SEVERITY_VALUE_3: 3,
  SEVERITY_VALUE_4: 4,
  TEMPERATURE_UNIT_ZERO: "0",
  RPM_LESS_THAN_600: "RPM < 600",
  RPM_GREATER_THAN_600: "RPM > 600",
  VIBRATION_UNIT_ACCLRN_PEAK_IN_G: 1,
  VIBRATION_UNIT_ACCLRN_CAL_PEAK_IN_G: 2,
  VIBRATION_UNIT_ACCLRN_RMS_IN_G: 3,
  VIBRATION_UNIT_ACCLRN_PEAK_IN_MPS2: 4,
  VIBRATION_UNIT_ACCLRN_CAL_PEAK_IN_MPS2: 5,
  VIBRATION_UNIT_ACCLRN_RMS_IN_MPS2: 6,
  VIBRATION_UNIT_VELOCITY_CAL_PEAK_IN_IPS: 7,
  VIBRATION_UNIT_VELOCITY_RMS_IN_IPS: 8,
  VIBRATION_UNIT_VELOCITY_CAL_PEAK_IN_MMPS: 9,
  VIBRATION_UNIT_VELOCITY_RMS_IN_MMPS: 10,
  VIBRATION_UNIT_DISPLACEMENT_RMS_IN_MILS: 11,
  VIBRATION_UNIT_DISPLACEMENT_RMS_IN_MICRON: 12,
  VIBRATION_UNIT_DISPLACEMENT_CAL_PK_PK_IN_MILS: 13,
  VIBRATION_UNIT_DISPLACEMENT_CAL_PK_PK_IN_MICRON: 14,
  BEARING_CONDITION_UNIT: " CF+",
  VIBRATION_UNIT_CAP_G: "G",
  VIBRATION_SEVERITY_1: 1,
  VIBRATION_SEVERITY_2: 2,
  VIBRATION_SEVERITY_3: 3,
  VIBRATION_SEVERITY_4: 4,
  VIBRATION_AGGREGATION_LABEL_PK: "(pk)",
  VIBRATION_AGGREGATION_LABEL_RMS: "(rms)",
  VIBRATION_AGGREGATION_LABEL_CAL_PK: "(cal pk)",
  VIBRATION_AGGREGATION_LABEL_CAL_PK_PK: "(cal pk-pk)",
  VIBRATION_AGGREGATION_LABEL_DEAULT: "",
};

export const MILLI_SECONDS_CONVERSION = {
  HOURS: 3.6e6,
  MINUTES: 60000,
};

export const MANUAL_ENTRY = {
  DEVICE_ID: "25F1A2F0-B98F-11E2-9678-15B654818C3B",
};

export const FEATURE_ID = {
  WORK_ORDERS: "2687CB30-EBA6-444F-A4BA-9C84DA7745BD",
  ASSET_HEALTH: "992A0C8B-40A7-46BA-991C-DABC3B9BE064",
  CONDITIONAL_MONITORING: "5693b576-05fe-4dd0-a754-0b3f497eac90",
};

export const FLUKE_DEVICE_TYPES = {
  FLUKE_289FC: "FLUKE 289",
  FLUKE_393FC: "393FC",
  FLUKE_283FC: "283FC",
};

export const F283FC_MODE_ATTRIBUTES_PQ = {
  RELATIVE: 8,
}